export const errorMessages = {
	LEM1: {
		header: "Vi känner inte igen dig",
		message:
			"Det kan ha olika orsaker, beroende på vilken typ av medlemskap du har. \n <h3 class='information-box__sub-header'>För dig som är villaägarmedlem</h3>För att kunna logga in med BankID måste du först aktivera BankID-inloggning på Mina Sidor. Logga in med lösenord för att komma till Mina Sidor. \n\n<h3 class='information-box__sub-header'>För dig som är samfällighetsmedlem</h3>Inloggning med BankID är tyvärr inte tillgängligt för samfällighetsmedlemmar. Logga in med lösenord istället. \n\nOm problemet kvarstår kan det bero på att du inte är medlem i Villaägarna ännu.",
		link: "https://www.villaagarna.se/kontakta/expertradgivning/",
		linkText: "Behöver du hjälp med inloggning?",
		severity: 1,
	},
	LEM2: {
		header: "Inloggning misslyckades",
		message:
			"Vi kunde inte logga in dig. Kan det vara så att du har aktiverat BankId som autentiseringsmetod? Är du säker på att du har ett aktivt medlemskap hos Villaägarna? Kontakta gärna medlemsservice om du har frågor!",
		severity: 1,
	},
	LEM3: {
		header: "Inloggning misslyckades",
		message: "Ett fel uppstod. Vänligen kontakta medlemsservice.",
		severity: 1,
	},
	AEM1: {
		header: "Aktivering misslyckades",
		message:
			"Dina personuppgifter överrenstämmer inte med de i vårat medlemssystem. Vänligen kontakta medlemsservice.",
		severity: 1,
	},
	AEM2: {
		header: "Aktivering misslyckades",
		message: "Du har redan aktiverat BankId som inloggningsmetod.",
		severity: 1,
	},
	AEM3: {
		header: "Aktivering misslyckades",
		message: "Ett fel uppstod. Vänligen kontakta medlemsservice.",
		severity: 1,
	},
};

const fallbackErrorMessage = {
	header: "Oj, något gick fel",
	message:
		"Ett fel verkar uppstått. Vänligen försök igen eller kontakta medlemsservice.",
	link: "villaagarna.se",
	linkText: "Tillbaka",
	severity: 1,
};

export function setErrorMessage(errorMessage) {
	$("#error-box").removeClass("hidden");
	if (errorMessages[errorMessage]) {
		$("#error-message-header strong").text(
			errorMessages[errorMessage].header
		);
		$("#error-message-text").html(errorMessages[errorMessage].message);
		if (errorMessages[errorMessage].link) {
			$("#error-message-link").attr(
				"href",
				errorMessages[errorMessage].link
			);
			$("#error-message-link").text(errorMessages[errorMessage].linkText);
		}
	} else {
		$("#error-message-header strong").text(fallbackErrorMessage.header);
		$("#error-message-text").text(fallbackErrorMessage.message);
	}
}
